import React from "react";

/**
 * AcademyChromeToggle, a floating "Focus" button shown throughout the Learning
 * Academy. The global site header/menu is hidden by default (focus mode) so
 * kids stay on their lessons; a grown-up can tap this to TEMPORARILY reveal the
 * site menu (e.g. to switch who's learning or leave to another page). It resets
 * to hidden on the next navigation, so focus is always the default.
 */
const AcademyChromeToggle = ({ revealed, onToggle }) => {
  return (
    <button
      type="button"
      data-testid="academy-chrome-toggle"
      onClick={onToggle}
      aria-pressed={revealed}
      aria-label={revealed ? "Hide the site menu and return to focus mode" : "Show the site menu"}
      title={revealed ? "Back to focus (hide menu)" : "Show site menu (change learner or leave)"}
      style={{
        position: "fixed",
        top: 14,
        right: 176,
        zIndex: 9999,
        padding: "9px 15px",
        borderRadius: 999,
        background: revealed
          ? "linear-gradient(135deg,#f59e0b,#f43f5e)"
          : "linear-gradient(135deg,#0ea5e9,#6366f1)",
        color: "#fff",
        border: "2px solid rgba(255,255,255,0.55)",
        boxShadow: "0 6px 22px rgba(14,165,233,0.5)",
        backdropFilter: "blur(6px)",
        cursor: "pointer",
        fontWeight: 800,
        fontSize: 12,
        letterSpacing: 0.2,
        display: "inline-flex",
        alignItems: "center",
        gap: 7,
      }}
    >
      <span style={{ fontSize: 14 }}>{revealed ? "🎯" : "☰"}</span>
      <span>{revealed ? "Focus Mode" : "Menu / Focus"}</span>
    </button>
  );
};

export default AcademyChromeToggle;
